import React from 'react';
import ReactDOM from 'react-dom';
import dva from 'dva';
import { browserHistory } from 'dva/router';
// Use this for dva v2.x
// import createHistory from 'history/createBrowserHistory'
import { LocaleProvider } from 'antd';
import { addLocaleData, IntlProvider } from 'react-intl';

import createLoading from './models/loading';
import registerServiceWorker from './registerServiceWorker';

import appModel from './models/app';
import notificationModel from './models/notification';
import groupModel from './models/group';
import tagModel from './models/tag';
import itemUnitModel from './models/item_unit';
import accountModel from './models/account';
import contactModel from './models/contact';
import employeeModel from './models/employee';
import itemModel from './models/item';
import bankAccountModel from './models/bank_account';
import fileTagModel from './models/file_tag';
import commentModel from './models/comment';
import stateModel from './models/state';
import tourModel from './models/tour';

import router from './router';

import './vi-VN';

// Disable log in production
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_CONFIG === 'production') {
  console.log = () => { };
}

const appLocale = window.appLocale;

addLocaleData(appLocale.data);

// Use this for dva v2.x
// const history = createHistory();

const history = browserHistory;
// 1. Initialize
const app = dva({
  ...createLoading({
    effects: true,
    trackedActions: [
      'app/getUserProfile', 'app/getSpaceSettings', 'app/getSpaceUsers',
      'account/query', 'item/query', 'itemUnit/query',
      'group/query', 'bankAccount/query', 'contact/query', 'employee/query',
    ],
  }),
  history,
  onError(error) {
    console.log('app error', error);
  },
});

// 2. Model
app.model(appModel);
app.model(notificationModel);
app.model(accountModel);
app.model(bankAccountModel);
app.model(groupModel);
app.model(tagModel);
app.model(itemModel);
app.model(itemUnitModel);
app.model(contactModel);
app.model(employeeModel);
app.model(fileTagModel);
app.model(commentModel);
app.model(tourModel);
app.model(stateModel);

// 3. Router
app.router(router);

// 4. Start
const App = app.start();

// 5. Render
ReactDOM.render(
  <LocaleProvider locale={appLocale.antd}>
    <IntlProvider locale={appLocale.locale} messages={appLocale.messages}>
      <App />
    </IntlProvider>
  </LocaleProvider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js